import { createStore } from "vuex";
import apiAccess2 from '@/router/apiAccess2.js';
import casinoGames from '@/store/modules/main/casinoGames.js';
import News from "./modules/News";
import Notifications from "./modules/Notifications";

const store = createStore({
  modules: {
    api: apiAccess2,
    casinoGames: casinoGames,
    News: News,
    Notifications: Notifications
  },
  state() {
    return {
      prefilled_nickname: null,
      prefilled_password: null,
    };
  },
  getters: {
    prefilled_nickname(state) {
      return state.prefilled_nickname;
    },
    prefilled_password(state) {
      return state.prefilled_password;
    },
  },
  mutations: {
    setPrefilledLoginValue(state, payload) {
      state.prefilled_nickname = payload.nickname;
      state.prefilled_password = payload.password;
    },
  },
  actions: {
    setPrefilledLoginValue(context, payload) {
      context.commit("setPrefilledLoginValue", payload);
    },
  },
});

export default store;
